import React, { useEffect } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import vHistory, { VPathKey } from './history';
import socketStore from 'store/socket';
import clientStore from 'store/client-store';
import { eventTrack } from './event-track';
import qs from 'query-string';
import { VAction } from '@/interfaces/event-log';
interface IProps extends RouteProps {
  pathKey: VPathKey;
  agreeCheck?: boolean;
  sessionCheck?: boolean;
  allowAccess?: boolean;
}

const getAgreeStatus = () => {
  return socketStore.getSocketData().consentAgreed;
};

const getSessionInfo = () => {
  return clientStore.getSession();
};

const GuardedRoute = (props: IProps) => {
  const { pathKey, agreeCheck, allowAccess, sessionCheck, path, component, ...rest } = props;

  useEffect(() => {
    console.log('to page', pathKey);
    vHistory.updateCurrentPathKey(pathKey);
    eventTrack.pushEvent({
      action: VAction.PAGE_EVENT,
      target: {
        pageName: pathKey,
        params: location.search ? qs.parse(location.search) : undefined,
      },
    });
    eventTrack.setCurrentPage({
      pageName: pathKey,
      params: location.search ? qs.parse(location.search) : undefined,
    });
    return () => {
      console.log('from page', pathKey);
    };
  }, []);

  // just for test/staging, use demo page
  // if (process.env.MODE === 'production' && pathKey === VPathKey.DEMO) {
  //   return <Redirect to={vHistory.getPathnameByKey(VPathKey.COMPLETE)} />;
  // }

  // for test
  // check if client get the session info
  if (sessionCheck && !getSessionInfo()) {
    return <Redirect to={vHistory.getPathnameByKey(VPathKey.COMPLETE)} />;
  }
  // check if client agree the consent
  if (agreeCheck && !getAgreeStatus()) {
    return <Redirect to={vHistory.getPathnameByKey(VPathKey.CONSENT)} />;
  }

  return <Route path={path} component={component} />;
};

export default GuardedRoute;
